import React from "react";
import numeral from "numeral";

import { RefiAnalysisLineChart } from "../../../pdf-export-templates";
import "./styles.css";

export const RefiSavingsModule = ({ data = {}, term }) => {
  const {
    refiLoanInterest,
    prepaymentPenalty,
    currentLoanInterest,
    interestSavings,
    netCostToRefi
  } = data;

  const displayValues = [
    {
      label: "Interest Paid on Current Loan",
      value: currentLoanInterest
    },
    {
      label: "Interest Paid on Refinanced Amount",
      value: refiLoanInterest
    },
    {
      label: "Prepay Penalty",
      value: prepaymentPenalty
    },
    {
      label: "Interest Savings",
      value: currentLoanInterest - refiLoanInterest
    }
  ];

  const formattedCurrency = value => (value >= 0 ? numeral(value).format("$0,0") : `(${numeral(value).format("$0,0")})`);

  return (
    <div className="supervised-analysis-body-wrapper">
      <div className="supervised-analysis-body-chart-wrapper">
        <RefiAnalysisLineChart
          companyPrimaryColor="#005AA9"
          companySecondaryColor="#0F9AD6"
          providedExistingLoanInterestPaid={currentLoanInterest}
          providedRefiLoanInterestPaid={refiLoanInterest}
          term={term}
        />
      </div>
      <div className="supervised-analysis-body-stats-wrapper">
        <div className="supervised-stats-layout supervised-stats-header">
          <div>Refi Savings</div>
          <div>{netCostToRefi ? formattedCurrency((currentLoanInterest - refiLoanInterest) - prepaymentPenalty) : "--"}</div>
        </div>
        {displayValues.map(({ label, value }, idx) => <div className="supervised-stats-layout supervised-stats-body" key={idx}>
          <div>{label}</div>
          <div>{value ? formattedCurrency(value) : "--"}</div>
        </div>)}
      </div>
    </div>
  );
};
